import {capitalize, Chip, Grid} from "@mui/material";
import React from "react";
import {useStores} from "~/stores";
import {
    GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
    gridColumnLookupSelector,
    useGridApiContext,
    useGridSelector
} from "@mui/x-data-grid-premium";
import {
    BUSINESS_UNIT_FILTER_FIELD,
    REVIEW_CHOICE_FIELD
} from "../../../../controllers/CategorizationReviewPageFilterController.ts";
import moment from "moment/moment";
import {observer} from "mobx-react-lite";
import {CAT_EQ_OPERATOR, CAT_NEQ_OPERATOR} from "../filters/CategoryFilter.tsx";

/**
 * Taken from https://mui.com/x/react-data-grid/components/toolbar/#filter-bar
 */
export const ToolbarFilterChips: React.FC = observer(() => {
    const {p, categorizationReviewStore} = useStores()
    const apiRef = useGridApiContext();
    const filterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;
    const columns = useGridSelector(apiRef, gridColumnLookupSelector);

    return <Grid container spacing={1}>
        {/*filterModel: ({filterController.gridFilterModel.items.length})={JSON.stringify(filterController.gridFilterModel.items.map(f => f.value))}<br/>*/}
        {/*API filterModel: ({filterController.apiGridFilterModel.items.length})={JSON.stringify(filterController.apiGridFilterModel.items.map(f => f.value))}<br/>*/}

        {filterController.gridFilterModel.items.filter(f => f?.value).map((filter) => {
            const column = columns[filter.field];
            const fieldName = (
                filter.field === GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD
                    ? p.supplierDataName // Columns might not be loaded immediately, so we use the profileStore here...
                    : (column?.headerName ?? filter.field)
            );

            let operator = '';
            let label: string;

            if (filter.operator === CAT_EQ_OPERATOR.operatorValue) {
                // noinspection TypeScriptUnresolvedReference
                operator = apiRef.current.getLocaleText('filterOperatorEquals');
                label = `${fieldName} ${operator} previous`;
            } else if (filter.operator === CAT_NEQ_OPERATOR.operatorValue) {
                // noinspection TypeScriptUnresolvedReference
                operator = apiRef.current.getLocaleText('filterOperatorDoesNotEqual');
                label = `${fieldName} ${operator} previous`;
            } else if (filter.operator === 'between') {
                // To avoid missing translation
                // See https://github.com/mui/mui-x/issues/13217
                // Unicode: <= -> \u2264    >= -> \u2265
                const lowerBound = (filter.value?.at(0) ?? '0') + ' \u2264 ';
                const upperBound = ' \u2264 ' + (filter.value?.at(1) ?? '100');
                label = `${filter.value?.at(0) ? lowerBound : ''}${fieldName}${filter.value?.at(1) ? upperBound : ''}`;
            } else {
                const lookup = `filterOperator${capitalize(filter.operator)}` as 'filterOperatorContains';
                // noinspection TypeScriptUnresolvedReference
                operator = apiRef.current.getLocaleText(lookup);
                label = `${fieldName} ${operator} ${filter.value ?? ''}`;
            }

            if (filter.field === BUSINESS_UNIT_FILTER_FIELD) {
                label = `${fieldName} ${operator} ${filterController.selectedBusinessUnitName}`;
            } else if (filter.operator === 'between' && column?.type === 'date') {
                // filter.value is [Date, Date] here, not a single value - format each bound
                const formatBound = (d: unknown) => d ? moment(d as Date).format('L') : '';
                const lowerBound = formatBound(filter.value?.at(0)) + ' ≤ ';
                const upperBound = ' ≤ ' + formatBound(filter.value?.at(1));
                label = `${filter.value?.at(0) ? lowerBound : ''}${fieldName}${filter.value?.at(1) ? upperBound : ''}`;
            } else if (column?.type === 'date') {
                label = `${fieldName} ${operator} ${moment(filter.value).format('L')}`;
            } else if (filter.field === REVIEW_CHOICE_FIELD) {
                label = `Not accepted yet`;
            }

            return <Grid key={filter.id} size="auto">
                <Chip
                    label={label}
                    onDelete={() => filterController.removeFilter(filter.id)}
                    sx={{mx: 0.25}}
                />
            </Grid>;
        })}
    </Grid>
})